import { Link } from "react-router-dom";


const NotFound = () => {
  return (
    <div className="errorpage">
      <div className="container">
        <div className="errorpage_content">
          <div className="errorpage_title">
            <h1><b>404</b><span>ошибка</span></h1>
          </div>
          <div className="errorpage_text">
            <p>Извините, страница которую Вы ищете,<br/> не может быть найдена</p>
            <Link to="/" className="errorpage_link">Вернуться<br/> на главную</Link>
          </div>
        </div>
      </div>
    </div>
  )
};
export default NotFound;